import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputBase,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CoachSideBar from "./Profile/CoachSideBar";
import Navbar from "../Navbar";
import SearchIcon from "@mui/icons-material/Search";
import profilePhoto from "../../images/profilePhoto.png";
import Rating from "@mui/material/Rating";
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import { servicefeature } from '../../styles/style'
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import { useDispatch, useSelector } from "react-redux";
import { createService } from "../../actions/userAuth";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

export default function PreviewService() {

  const { user } = useSelector((state) => ({ ...state }));
  const [service, setService] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if item is present in local storage
    const storedService = localStorage.getItem("serviceData");
    if (storedService) {
      // Parse the stored value and set the service state
      console.log("local storage payload = ", storedService);
      let payloadData = JSON.parse(storedService)
      setService(payloadData);

    }
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    dispatch(createService(service, (data) => {
      enqueueSnackbar("Service created successfully", { variant: "success" });
      setLoading(false);
      navigate("/coach/services-status");
    }, (err) => {
      enqueueSnackbar("Error Occured! Please try again", { variant: "warning" });
      setLoading(false);
    }))
  }

  return (
    <Layout>
      <UserLayout userRole={"coach"}>

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between', mt: 8, borderRadius: '10px' }}>
                        <Typography className="heading1bold"> Preview Service</Typography>
                        <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
                            <TextField
                                sx={{ marginLeft: '1rem' }}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                              
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Grid>
                    </Box>


       

        <Box p={{md:5, xs:1}}>
          <Paper
            sx={{
              width: "100%",
              bgcolor: "#F8FAFF",
              boxShadow:
                "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
              border: "1.72px solid #cedefd",
            }}
          >
            <Box sx={{ p: 3, display: "flex", flexDirection:{md:'row', xs:'column'},  justifyContent: "center" }}>
              <Box>
                <img
                  src={user.avatar}
                  alt="profilePhoto"
                  style={{ height: "200px" }}
                />
              </Box>
              <Box sx={{ fontFamily: "Inter", px: 3 }}>
                <Typography
                  sx={{
                    lineHeight: "43px",
                    opacity: ".5",
                  }}
                  className="text1Mid"
                >
                  (8784421)
                </Typography>
                <Typography
                  sx={{
                    lineHeight: "40px",
                    color: "#061C3D",
                  }}
                  className="subHeading2Bold"
                >
                  {user.fullName}
                </Typography>
                <Rating
                  name="half-rating-read"
                  defaultValue={4}
                  precision={0.5}
                  readOnly
                  sx={{ py: 1 }}
                />
                <Typography
                  sx={{
                    lineHeight: "35px",
                  }}
                  className="text1Mid"
                >
                  Lorem ipsum dolor sit amet consectetur. Turpis in sapien in
                  a nunc nibh volutpat. Massa mattis molestie amet dui
                  volutpat. Tellus lacinia pulvinar pharetra viverra morbi
                  tincidunt mi mus.
                </Typography>
              </Box>
            </Box>
          </Paper>



          <Box my={'5'}>
            <Typography
              sx={{
                lineHeight: "5rem",
                textAlign: "left",
              }}
              className="subHeading1Bold"
            >
              About {user.fullName}
            </Typography>
            <Typography
              sx={{
                lineHeight: "2rem",
                textAlign: "left",
              }}
              className="text1Mid">
              Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus. Lobortis maecenas pulvinar pretium est morbi ut diam pulvinar. Pellentesque id lacus id elit leo cursus purus tempus tortor. Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
            </Typography>
            <Typography
              sx={{
                lineHeight: "2rem",
                textAlign: "left",
                mt: 3
              }}
              className="text1Mid">
              Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
            </Typography>
          </Box>

          <Paper sx={{
            border: '1.28px solid #D2D2D24D', boxShadow: '0px 40.996337890625px 81.99267578125px -15.373626708984375px #3665D014', my: 3
          }}>
            <Box p={3}>
              <Typography sx={{
                lineHeight: "3rem",
                textAlign: "left",
                mt: 2
              }}
                className="heading2bold">Service Name : {service.serviceName}</Typography>
              <Box>
                <Typography sx={{
                  lineHeight: "4.25rem",
                  textAlign: "left",
                  mt: 1
                }}
                  className="subHeading2Bold">Service Detail</Typography>
                <ul style={{
                  lineHeight: "1.75rem",
                  textAlign: "left",
                }}
                  className="text1Mid">
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. </li>
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. </li>
                </ul>
              </Box>
              <Box>
                <Typography sx={{
                  lineHeight: "4rem",
                  textAlign: "left",
                  mt: 1
                }}
                  className="heading2bold">Service Detail by Coach</Typography>
                <ul style={{
                  lineHeight: "1.75rem",
                  textAlign: "left",
                }}
                  className="text1Mid">
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. </li>
                  <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                  <li style={{ paddingBottom: '20px', fontWeight: 700, }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. </li>
                </ul>
              </Box>
              <Box>
                <Box>
                  <Typography sx={{
                    lineHeight: "5rem",
                    textAlign: "left",
                    mt: 1
                  }}
                    className="heading2bold">Medium Available</Typography>
                  <Box display={{ display: 'flex', flexDirection:{md:'row', xs:'column'}, gap: 15 }}>
                    <Box sx={{ bgcolor: '#2544EE', color: '#fff', px: 3, py: 1, height:'45px', borderRadius: '30px' }}> <VideocamRoundedIcon /></Box>

                    <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Language:  :  <span style={{ color: '#2544EE' }}> {service.language}</span></Typography></Box>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', flexDirection:{md:'row', xs:'column'}, pt: 5, gap: 3, ml: 5 }}>
                  <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Number of Session:  :  <span style={{ color: '#2544EE' }}> {service.numberOfSessions}</span></Typography></Box>
                  <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Service Duration  : <span style={{ color: '#2544EE' }}> {service.totalDuration} Minutes </span></Typography></Box>
                  <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Duration/Session:  :<span style={{ color: '#2544EE' }}>  {service.durationPerSession} Minutes </span></Typography></Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{
              bgcolor: '#F8FAFF', border: '1px solid #D2D2D299', my: 5, boxShadow: '0px 22.98290252685547px 45.96580505371094px -8.6185884475708px #3665D014'
            }}>
              <Typography sx={{
                py: 3,
                textAlign: "center",
              }}
                className="heading2bold">Price: ₹{service.suggestedPrice}/-</Typography>
            </Box>
            <Box sx={{ textAlign: 'center', }}>
              <Button variant="contained" className="text1Mid" sx={{ px: 5, py: 2, bgcolor: '#2544EE', borderRadius: '30px', mb: 5 }} onClick={handleSubmit} disabled={loading}>
                {
                  loading
                    ?
                    <CircularProgress size={24} />
                    :
                    "Create"
                }
              </Button>
              <Button variant="outlined" className="text1Mid" sx={{ px: 5, py: 2, color: '#2544EE', borderRadius: '30px', ml: 5, mb: 5 }} onClick={() => navigate("/coach/services-status")}>Cancel</Button>
            </Box>
          </Paper>
        </Box>
      </UserLayout>
    </Layout>
  );
}
